<template>
    <div class="map-places">
        <RefreshButton v-if="($route.params.tab === 'buildings')" @click="refreshBuildings">
            <h2>Budovy</h2>
        </RefreshButton>
        <h2 v-else-if="($route.params.tab === 'map')"> Interaktivní mapa </h2>
        <h2 v-else>Místa</h2>

    <div class="map-places-head align-center d-none d-sm-flex">
      <v-tabs stacked color="light-green">
        <v-tab :to="{name: 'map', params: {'tab': 'places'}}">
          <v-icon>room</v-icon>
          Místa
        </v-tab>
        <v-tab :to="{name: 'map', params: {'tab': 'buildings'}}">
          <v-icon>home</v-icon>
          Budovy
        </v-tab>
        <v-tab :to="{name: 'map', params: {'tab': 'map'}}">
          <v-icon>map</v-icon>
          Mapa
        </v-tab>
      </v-tabs>
      <v-spacer/>
      <PrimaryButton v-if="($route.params.tab !== 'buildings' && $route.params.tab !== 'map' )" @click="goToDetail('place','new')">Přidat místo</PrimaryButton>
      <PrimaryButton v-if="($route.params.tab === 'buildings')" @click="goToDetail('building', 'new')">Přidat Budovu</PrimaryButton>
    </div>


    <!-- ONLY FOR SMALLER SCREENS -->
    <div class="d-block d-sm-none">
      <v-btn
        class="my-3"
        size="small"
        color="primary"
        v-if="$route.params.tab === 'places'"
        @click="goToDetail('place', 'new')"
        > Přidat místo</v-btn
      >
      <v-btn
        class="my-3"
        size="small"
        color="primary"
        v-if="$route.params.tab === 'buildings'"
        @click="goToDetail('building', 'new')"
        >Přidat budovu</v-btn
      >

      <div class="d-flex d-sm-none mt-2" style="justify-content: space-between">
        <mobile-tab to="places" :active="$route.params.tab === 'places'">
          <template v-slot:icon>place</template>
          <template v-slot:title>MÍSTA</template>
        </mobile-tab>
        <mobile-tab to="buildings" :active="$route.params.tab === 'buildings'">
          <template v-slot:icon>home</template>
          <template v-slot:title>BUDOVY</template>
        </mobile-tab>
        <mobile-tab to="map" :active="$route.params.tab === 'map'">
          <template v-slot:icon>map</template>
          <template v-slot:title>MAPA</template>
        </mobile-tab>
      </div>
    </div>

        <v-tabs-window :model-value="$route.params.tab" :touchless="true">
            <v-tabs-window-item value="places">
                <Places></Places>
            </v-tabs-window-item>
            <v-tabs-window-item value="buildings">
                <Buildings ref="buildingsRef"></Buildings>
            </v-tabs-window-item>
            <v-tabs-window-item value="map">
                <MapInteractive></MapInteractive>
            </v-tabs-window-item>
        </v-tabs-window>
    </div>
</template>

<script>
    import MapInteractive from "./MapInteractive";
    import PrimaryButton from "../../components/buttons/PrimaryButton";
    import RefreshButton from "../../components/buttons/RefreshButton";
    import Places from "./Places.vue";
    import Buildings from "./Buildings.vue";
    import MobileTab from "../../components/layout/MobileTab.vue";

    export default {
        name: "MapModule",

        components: {
             MapInteractive,
             PrimaryButton,
             RefreshButton,
             Buildings,
             Places,
             MobileTab,
         },

        data() {
            return {
                tab:null,
                map: null
            }
        },

        methods: {
            goToDetail(placeType, PlaceId) {
                this.$router.push({name:'mapDetail',params:{type: placeType, id: PlaceId}});
            },

            refreshBuildings() {
                this.$refs.buildingsRef.fetchAllBuildings();
            }
        }
    }
</script>

<style scoped>
    .map-places-head {
        padding-bottom: 1rem;
    }

    .map-places {
        width: 100%;
        display: block;
    }
</style>
